import loadable from '@loadable/component'

export default [
  {
    path: '/union/leadermenu',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionLeaderMenu" */ '~/pages/Union/Leader/LeaderMenu'
        )
    ),
  },
  {
    path: '/union/leader/signup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionLeaderSignup" */ '~/pages/Union/Leader/SignUp'
        )
    ),
  },
  {
    path: '/union/leader/settlement',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionLeaderSettlement" */ '~/pages/Union/Leader/Settlement'
        )
    ),
  },
  {
    path: '/union/leader/data',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionLeaderData" */ '~/pages/Union/Leader/Data'
        )
    ),
  },
  // 工会长提现页面
  {
    path: '/union/leader/WithdrawSalary/Main',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-leader-WithdrawSalary/Main" */ '~/pages/Union/Leader/WithdrawSalary'
        )
    ),
  },
  {
    path: '/union/anchormenu',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionAnchorMenu" */ '~/pages/Union/Anchor/AnchorMenu'
        )
    ),
  },
  {
    path: '/union/anchor/admininvite',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionAnchorInviteUserByAnchor" */ '~/pages/Union/Anchor/InviteUserByAnchor'
        )
    ),
  },
  {
    path: '/union/anchorquit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionAnchorQuit" */ '~/pages/Union/Anchor/AnchorQuit'
        )
    ),
  },
  {
    path: '/union/anchorquitlist',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionLeaderAnchorQuitList" */ '~/pages/Union/Leader/AnchorQuitList'
        )
    ),
  },
  // 主播和公会长都会用的payoneer绑定
  {
    path: '/union/payoneerBind',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionPayoneerBind" */ '~/pages/Union/PayoneerBind'
        )
    ),
  },
  // 绑定payoneer中转页面
  {
    path: '/union/payoneerMiddlePage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionPayoneerMiddlePage" */ '~/pages/Union/PayoneerBind/middlePage'
        )
    ),
  },
  // 主播签约提现页面
  {
    path: '/union/anchor/WithdrawSalary/Main',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WithdrawSalary/Main" */ '~/pages/Union/Anchor/WithdrawSalary'
        )
    ),
  },
  // 工会长和主播的提现页面共用的提现记录地址
  {
    path: '/union/anchor/WithdrawSalary/History',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WithdrawSalary/History" */ '~/pages/Union/Anchor/WithdrawSalary/SubPages/History'
        )
    ),
  },
  {
    path: '/union/anchor/WithdrawSalary/SignUp',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WithdrawSalary/SignUp" */ '~/pages/Union/Anchor/WithdrawSalary/SubPages/SignUp'
        )
    ),
  },
  {
    path: '/union/anchor/SalaryFeedback',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SalaryFeedback" */ '~/pages/Union/Anchor/SalaryFeedback'
        )
    ),
  },
  {
    path: '/union/medal',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-union-medal" */ '~/pages/Union/Medal')
    ),
  },
  // 工会长和主播共用的各种支付方式的绑定页面
  {
    path: '/union/GatherInfo',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-GatherInfo" */ '~/pages/Union/GatherInfo'
        )
    ),
  },
  {
    path: '/union/GatherInfo/PayoneerNew',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-GatherInfo-PayoneerNew" */ '~/pages/Union/GatherInfo/PayoneerNew'
        )
    ),
  },
  {
    path: '/union/GatherInfo/PayoneerOther',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-GatherInfo-PayoneerOther" */ '~/pages/Union/GatherInfo/PayoneerOther'
        )
    ),
  },
  // 生成他人绑定Payoneer专属链接
  {
    path: '/union/GatherInfo/PayoneerOther/Link',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-GatherInfo-PayoneerOthe-Link" */ '~/pages/Union/GatherInfo/PayoneerOther/link'
        )
    ),
  },

  // 工会长和主播共用的主播中心右上角菜单 取代之前的/union/leadermenu和/union/anchormenu 不再分开写了 20220630
  {
    path: '/union/SettingMenu',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-SettingMenu" */ '~/pages/Union/SettingMenu'
        )
    ),
  },
  // 工会长和主播共用的改变默认收款方式
  {
    path: '/union/SalaryMode',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-SalaryMode" */ '~/pages/Union/GatherInfo/SalaryMode'
        )
    ),
  },
  // 薪资钱包
  {
    path: '/union/SalaryWallet',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-SalaryWallet" */ '~/pages/Union/SalaryWallet'
        )
    ),
  },
  // 薪资钱包 交易
  {
    path: '/union/SalaryWallet/trade',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-SalaryWallet-trade" */ '~/pages/Union/SalaryWallet/trade'
        )
    ),
  },
  // 薪资钱包 改变提现方式
  {
    path: '/union/SalaryWallet/change',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-SalaryWallet-change" */ '~/pages/Union/SalaryWallet/change'
        )
    ),
  },
  // 薪资钱包 记录
  {
    path: '/union/SalaryWallet/log',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-union-SalaryWallet-change" */ '~/pages/Union/SalaryWallet/History'
        )
    ),
  },
]
